<script>
const FRONT_URL = process.env.VUE_APP_FRONTEND_URL;

import UserAuth from "@/mixins/UserAuth";
import roscongressUrl from "@/utils/roscongressUrl";

export default {
    name: "DocumentSettings",
    components: {
        Comments: () => import('@/components/commonComponents/Comments'),
        BpStatusStepper: () => import('@/components/commonComponents/BpStatusStepper.vue'),
        BpApproveDecline: () => import('@/components/commonComponents/BpApproveDecline'),
        VBtnMenu: () => import('@/components/commonComponents/VBtnMenu'),
        VBtnMenuItem: () => import('@/components/commonComponents/VBtnMenuItem'),
        History: () => import('@/components/commonComponents/History'),
        VDialogFormDraggable: () => import('@/components/commonComponents/VDialogFormDraggable'),
        DocumentSettingsCommon: () => import('./DocumentSettingsCommon'),
    },
    mixins: [
        UserAuth,
    ],
    props: {
        value: {
            type: Object,
            default: () => ({}),
        },
        loading: Boolean,
        disabled: Boolean,
        isModal: {
            type: Boolean,
            default: true,
        },
        draggable: Boolean,
        projectId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            isShow: false,
            tab: 'common',
            backupDocument: {},
            showDocument: null,
            isLoadingInternal: false,
            isSavingInternal: false,
            id: null,
        };
    },
    computed: {
        isDisabled() {
            return this.disabled || (this.isNew ?
                !this.user?.permissions?.byModule?.pdf?.canCreate :
                !(this.user?.permissions?.byModule?.pdf?.canUpdate && this.permissions?.canUpdate))
            ;
        },
        isLoading() {
            return this.loading || this.isLoadingInternal;
        },
        isSaving() {
            return this.isSavingInternal;
        },
        isCanSubmit() {
            return !this.isDisabled && !this.isLoading && !this.isSaving && this.$refs?.dialog?.wasModified && this.$refs?.dialog?.isValid;
        },
        isNew() {
            return this.documentId === 0;
        },
        isCanAction() {
            return !this.$refs?.dialog?.wasModified && !this.isLoading && !this.isSaving && !this.isNew && this.$refs?.dialog?.isValid;
        },
        isCanPublish() {
            return this.isCanAction && this.permissions?.canPublish;
        },
        document: {
            get() {
                return this.showDocument || this.value || {};
            },
            set(v) {
                this.$emit('input', v);
            }
        },
        projectUrl() {
            return this.$apiUrl.getReportsUrl({id_project: this.projectId});
        },
        documentUrl() {
            /* document.id нужен, когда документ сохраняется через этот компонент, но без его показа */
            return this.projectUrl + this.documentId;
        },
        documentId() {
            return this.id || this.document?.id || 0;
        },
        roscongressDocumentUrl() {
            const id_analytics = this.document?.id_analytics;
            return id_analytics && roscongressUrl.getDocumentUrl({id_analytics});
        },
        roscongressDocumentBitrixUrl() {
            const id_analytics = this.document?.id_analytics;
            return id_analytics && roscongressUrl.getDocumentBitrixUrl({id_analytics});
        },
        publishUrl() {
            return this.$apiUrl.getReportUrl({id_project: this.projectId, id: this.documentId})
        },
        permissions() {
            return this.document?.permissions || {};
        },
        dialogMaxWidth() {
            return this.isNew ? 900 : '80vw';
        },
    },
    watch: {
        tab() {
            // При смене вкладки возвращаем фокус диалогу
            this.$nextTick(() => {
                this.$refs.dialogContent?.focus();
                this.$refs.dialogContent?.$el?.focus();
            });
        },
        id: {
            handler(v) {
                if (!v) {
                    return;
                }
                this.reload();
            },
            immediate: true,
        }
    },
    methods: {
        loadDocument() {
            this.isLoadingInternal = true;
            return this.$api.get(this.documentUrl).then(resp => {
                if(!resp?.data?.data) {
                    this.notifyError('Данные о документе на сервере отсутствуют');
                    return;
                }
                this.notifySuccess(`Параметры документа ${resp.data.data.id} успешно загружены`);
                return resp.data.data;
            }).catch(this.notifyError).finally(() => {
                this.isLoadingInternal = false;
            });
        },
        reload() {
            this.loadDocument().then(data => {
                if(Object.hasOwn(this.$attrs, 'value')) {
                    this.$emit('input', data);
                } else {
                    this.showDocument = data;
                }
            });
        },
        show(id, data) {
            this.isShow = true;
            this.id = id;
            if (data) {
                this.showDocument = data;
            }
            this.backupDocument = this._.cloneDeep(this.document);
            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },
        getPdfCss() {
            return this.$api.request({
                baseURL: FRONT_URL,
                url: './css/pdf-render.css',
                method: 'get',
                maxContentLength: 100000,
                responseType: 'text',
                headers: { 'Content-Type': 'text/css' },
            }).catch(this.notifyError);
        },
        getTemplateCss(type, isBase = false) {
            return this.$api.request({
                baseURL: FRONT_URL,
                url: `./templates/${type}/template${isBase&&'_base'||''}.css`,
                method: 'get',
                responseType: 'text',
                maxContentLength: 4000000,
                headers: { 'Content-Type': 'text/css' },
            }).catch(this.notifyError);
        },
        /* async getTypesCss(isBase = false) { 
            const promiseArray = this._(this.pages).map(v => v.class).filter(v => !!v).uniq().map(v => this.getTemplateCss(v, isBase)).value();
            const cssArray = await Promise.all(promiseArray);
            return this.pages?.length 
                    ? this._.reduce(cssArray || [], (sum, v) => sum + v.data, '')
                    : ''; 
        }, */
        minifyCss(str) {
            return str.replace(/[\r\n\t]/ig, ' ')
                        .replace(/ +/ig, ' ')
                        .replace(/\/\*.*?\*\//ig, '');
            /*
            // Удаление комментариев
            const re1 = /(["'](?:[^"\\]+|\\.)*["'])|\/\*[\s\S]*?\*\//g;
            // Удаление лишних пробелов
            const re2 = /(["'](?:[^"\\]+|\\.)*["'])|\s*;?\s*(})|\s*([*$~^|]?=|[{};,>~+-]|!important\b)\s*|([[(:])\s+|\s+([\])])|\s+(:)\s*(?!([^{}"']*["'][^"\\]+["'])*{)|^\s+|\s+$|(\s)\s+/g;
            // Разбиваем текст на части, чтобы избежать переполнения стека
            const chunkSize = 10000; // Размер каждой части
            let result = '';
            for (let i = 0; i < str.length; i += chunkSize) {
                let chunk = str.slice(i, i + chunkSize);
                chunk = chunk.replace(re1, '$1'); // Удаляем комментарии
                chunk = chunk.replace(re2, '$1$2$3$4$5$6$7'); // Удаляем пробелы
                result += chunk;
            }
            return result;
            */
        },
        createDocument(templateType, settings) {
            this.isSavingInternal = true;
            const css = [];
            return Promise.all([
                this.getPdfCss().then(resp => { css[0] = resp.data; }),
                this.getTemplateCss(templateType).then(resp => { css[1] = resp.data; }),
                this.getTemplateCss(templateType, true).then(resp => { settings.immutable_css = this.minifyCss(resp.data); }),
            ]).then(() => {
                settings.css = this.minifyCss(css.join(''));
                return this.$api.post(this.projectUrl, settings).then(resp => {
                    if(!resp?.data?.data) {
                        this.notifyError(`Некорректный ответ сервера при создании документа`);
                        return;
                    }
                    this.$emit('create', resp.data.data);
                    this.notifySuccess(`Документ ${resp.data.data.id} создан успешно`);
                    return resp.data.data;
                }).catch(this.notifyError).finally(() => {
                    this.isSavingInternal = false;
                });
            }).catch(err => {
                this.notifyError(err);
                this.isSavingInternal = false;
            });
        },
        save(data) {
            data = data || this.document;
            if (!data) {
                return Promise.reject(new Error('Нет данных для сохранения'));
            }
            this.isSavingInternal = true;
            return this.$api.put(this.documentUrl, data).then(resp => {
                if(!resp?.data?.data) {
                    this.notifyError(`Некорректный ответ сервера при сохранении документа ${data?.id}`);
                    this.fallbackDocument();
                    return;
                }
                return resp.data.data;
            }).catch(err => {
                this.notifyError(err);
                this.fallbackDocument();
            }).finally(() => {
                this.isSavingInternal = false;
            });
        },
        fallbackDocument() {
            this._.forOwn(this.backupDocument, (v, k) => this.document[k] = v);
        },
        close(response) {
            this.isShow = false;
            this.resolve(response);
        },
        onClickSave(e, autoclose = true) {
            if (this.isNew) {
                this.createDocument('vef', this.showDocument).then(data => {
                    this.document = data;
                    this.id = data?.id;
                    if(autoclose) {
                        this.$nextTick(() => {
                            this.close(data);
                        });
                    }
                });
                return;
            }
            this.save().then(data => {
                if (!data) {
                    return;
                }
                this.$emit('save', data);
                this.notifySuccess(`Параметры документа ${data.id} успешно сохранены`);
                this.document = data;
                if (autoclose) {
                    this.$nextTick(() => {
                        this.close(data);
                    });
                }
            });
        },
        onClickCancel() {
            this.fallbackDocument();
            this.close();
        },
        onConfirmBpApproveDecline(data) {
            const url = this.$apiUrl.getReportApproveDeclineUrl({
                id: this.documentId,
                id_project: this.projectId,
                action: data.action,
                role: data.role,
            });
            return this.$api.put(url, data.form)
        },
        onSuccessBpApproveDecline() {
            this.reload();
        },
        onClickPublish() {            
            this.isSavingInternal = true;
            this.$api.post(this.publishUrl)
                .then(() => {
                    this.notifySuccess('Успешно опубликована.');
                    this.reload();
                })
                .catch(this.notifyError)
                .finally(() => {
                    this.isSavingInternal = false;
                });
        },
        onClickSaveAndContinue() {
            this.onClickSave(null, false);
        },
        onWrapperKeydown(e) {
            if (e.key === 'Escape' && !this.$refs?.dialog?.wasModified) {
                this.close();
            }
        },
    },
}
</script>

<template>
    <!--
      title-background="#2196F3"
      title-color="#fff"
-->
    <v-dialog-form-draggable
      v-model="isShow"
      :max-width="dialogMaxWidth"
      scrollable
      :hide-overlay="!isModal"
      :loading="isLoading"
      :saving="isSavingInternal"
      :title="`Параметры документа ${document.name}`"
      :ok-title="isNew ? 'Создать' : 'Изменить'"
      cancel-title="Отмена"
      @close="onClickCancel"
      @ok="onClickSave"
      :formData="document"
      :disabled="isDisabled"
      :draggable="draggable"
      ref="dialog"
    >
        <template v-slot:beforeText>
            <bp-status-stepper
                v-if="!isNew"
                :data="document"
                :published-url="roscongressDocumentUrl"
                :published-bitrix-url="roscongressDocumentBitrixUrl"
                published-url-tooltip="Открыть материал на Портале"
            ></bp-status-stepper>
            <div ref="dialogContent" tabindex="0" @keydown="onWrapperKeydown">    
                <v-tabs v-model="tab">
                    <v-tab tab-value="common">Общее</v-tab>
                    <v-tab v-if="!isNew" tab-value="history">История</v-tab>
                </v-tabs>
            </div>
        </template>
        <v-container class="pa-0">
            <v-row no-gutters>
                <v-col>
                    <v-tabs-items v-model="tab">
                        <v-tab-item value="common">
                            <document-settings-common
                                :document="document"
                                :is-disabled="isDisabled"
                            ></document-settings-common>
                        </v-tab-item>

                        <v-tab-item value="history">
<!--                                <v-card-title>История</v-card-title>-->
<!--                                <v-card-subtitle></v-card-subtitle>-->
<!--
                        </v-tab-item>
                        <v-tab-item value="history">
-->
                            <!--
                            @TODO Когда отрывается из документа (не из списка), ни тут, ни в комментариях, судя по всему id нет. document.id или что-то вроде того нужен, полагаю...
                            ---
                            сделал
                            -->
                            <history
                                ref="history"
                                :url="$apiUrl.getReportHistoryUrl({id_project: projectId, id: documentId})"
                            ></history>
                        </v-tab-item>
                    </v-tabs-items>
                </v-col>
                <v-col v-if="!isNew" cols="4">
                    <v-card height="100%" flat>
                        <v-toolbar flat>
                            <v-toolbar-title>Комментарии</v-toolbar-title>
                        </v-toolbar>
                        <comments
                            v-if="projectId && documentId"
                            ref="comments"
                            :url="$apiUrl.getReportCommentsUrl({id_project: projectId, id: documentId})"
                        ></comments>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <template v-slot:actions>
            <!-- {{isCanAction}}
            {{permissions}} -->
            <bp-approve-decline
                :is-can-action="isCanAction"
                :permissions="permissions"
                @confirm="onConfirmBpApproveDecline"
                @success="onSuccessBpApproveDecline"
                approve-question="Вы уверены что хотите отправить материал на утверждение?"
                approve-as-moderator-question="Вы уверены что хотите одобрить материал?"
                decline-question="Вы уверены что хотите отклонить материал?"
            >
                <template v-slot:append>
                    <v-btn
                        v-if="isCanPublish"
                        :disabled="!isCanPublish"
                        @click="onClickPublish"
                    >
                        Опубликовать
                    </v-btn>
                </template>
            </bp-approve-decline>
            <v-spacer></v-spacer>
            <v-btn @click="onClickCancel">
                Отмена
            </v-btn>
            <v-btn-menu
                :disabled="!isCanSubmit"
                @click="onClickSave"
                color="primary"
            >
                Сохранить
                <template v-slot:menu>
                    <v-btn-menu-item
                        @click="onClickSave"
                    >
                        ... и закрыть
                    </v-btn-menu-item>
                    <v-btn-menu-item
                        @click="onClickSaveAndContinue"
                    >
                        ... и продолжить
                    </v-btn-menu-item>
                </template>
            </v-btn-menu>
        </template>
    </v-dialog-form-draggable>
</template>


<style scoped lang="scss">
    .container {
        max-width: 100%!important;
    }
    .v-tabs {
        border-bottom: 1px solid #c0c0c044;
        margin-bottom: 20px;
    }
    .theme--light.v-tabs ::v-deep .v-tabs-bar {
        //background-color: #eee;
    }
    .v-dialog {
        .bp-status-stepper::v-deep {
            width: 100%;
            flex: 1 0 auto;
            .v-stepper__header {
                padding: 0 24px;
            }
        }
    }
</style>